module.exports = __webpack_public_path__ + "images/syuccho_kaitori_lp/strong_point/3@2x_37e4ab3a4ba79934f891a9f2f63bf4f2.png";